import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col" };
const _hoisted_3 = { ref: "card_number" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col" };
const _hoisted_6 = { ref: "card_expiryDate" };
const _hoisted_7 = { class: "col" };
const _hoisted_8 = { ref: "card_verificationCode" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "col" };
const _hoisted_11 = { ref: "card_holder" };
const _hoisted_12 = {
    key: 0,
    class: "text-danger mb-1 mt-1",
    role: "alert"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_field_container = _resolveComponent("g-field-container");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_g_field_container, {
                    label: "Kreditakarten-Nummer",
                    "error-message": _ctx.cardNumberErrors
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, null, 512)
                    ]),
                    _: 1
                }, 8, ["error-message"])
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_g_field_container, {
                    label: "Ablaufdatum",
                    "error-message": _ctx.cardExpiryDateErrors
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, null, 512)
                    ]),
                    _: 1
                }, 8, ["error-message"])
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_g_field_container, {
                    label: "Code",
                    "error-message": _ctx.cardVerificationCodeErrors
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, null, 512)
                    ]),
                    _: 1
                }, 8, ["error-message"])
            ])
        ]),
        _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_g_field_container, {
                    label: "Kreditakarten-Inhaber",
                    "error-message": _ctx.cardHolderErrors
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, null, 512)
                    ]),
                    _: 1
                }, 8, ["error-message"])
            ])
        ]),
        (_ctx.paymentErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.paymentErrors), 1))
            : _createCommentVNode("", true)
    ], 64));
}
